import "./Invitation.css"; 

const Invitation = () => {
  return (
    <p className="invitation">
      <em>Zapraszamy do wspólnej modlitwy!</em>
    </p>
  );
};

export default Invitation;
